import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Stack } from '@mui/material';
import { ExportsListExternalExportsTypeEnum } from '@askporter/client-grieg-lyric';
import { Typography } from '@askporter/component-library';
import type { TFunction } from '@askporter/config-provider';

interface ExportNameFieldProps {
  name: string;
  type: ExportsListExternalExportsTypeEnum;
  t: TFunction;
}

/**
 * The table cell for the export name & type.
 */
export const ExportNameField: React.FC<ExportNameFieldProps> = ({ name, type, t }: ExportNameFieldProps) => {
  return (
    <Stack>
      <Typography variant="body1" sx={{ fontWeight: '500', color: '#101828' }}>
        {name}
      </Typography>
      <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', color: '#475467' }}>
        <ArrowForwardIcon sx={{ fontSize: '1rem', color: '#475467' }} />
        {t(`export:export_list:table:export_type:${type.toLowerCase()}`)}
      </Typography>
    </Stack>
  );
};
